import type { OptionsDocument, QuoteDocument } from 'paintscout'
import React, { useState } from 'react'
import type { DialogProps } from '@paintscout/ui'
import {
  InputField,
  PhoneNumberInput,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  makeStyles
} from '@paintscout/ui'
import { getReviewRequestMessage } from '@paintscout/util/builder'
import MockTextMessage from '../../MockTextMessage'

const useStyles = makeStyles(() => {
  return {
    chatBubble: {
      whiteSpace: 'pre-line'
    },
    link: {
      color: 'inherit',
      overflowWrap: 'anywhere'
    }
  }
})

export interface RequestReviewDialogProps extends DialogProps {
  options: OptionsDocument
  contact?: QuoteDocument['contact']
  onConfirm?: (phoneNumber: string) => void
  onCancel?: () => void
}

const RequestReviewDialog = (props: RequestReviewDialogProps) => {
  const classes = useStyles()
  const { loading, options, contact, onCancel, onConfirm } = props
  const reviewRequestMessage = getReviewRequestMessage({ options })

  const [phoneNumber, setPhoneNumber] = useState<string>(contact?.phone_number)

  return (
    <Dialog fullWidth={true} maxWidth={'md'} {...props}>
      <DialogTitle>
        <Typography variant="h3">Request Google Review</Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <InputField
              placeholder="012.345.6789"
              onChange={(e) => setPhoneNumber(e.target.value)}
              fullWidth
              inputComponent={PhoneNumberInput}
              inputProps={{
                separator: options?.options?.phoneNumbers?.separator
              }}
              id="phone_number"
              label="Contact phone number"
              value={phoneNumber}
            />
          </Grid>
          <Grid item container justifyContent="center">
            <MockTextMessage>
              <Typography className={classes.chatBubble}>
                {`${reviewRequestMessage.message.trimEnd()} `}
                <a className={classes.link} href={reviewRequestMessage.link}>
                  {reviewRequestMessage.link}
                </a>
              </Typography>
            </MockTextMessage>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        showBorder={true}
        leftButton={
          <Button disabled={loading} onClick={onCancel} variant="textNoPadding">
            Cancel
          </Button>
        }
      >
        <Button disabled={loading} variant={'contained'} onClick={() => onConfirm(phoneNumber)}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RequestReviewDialog
